import { useEffect } from "react";

/**
 * Custom questions render inside the Formsort iframe, and that flow is
 * light-only. Force light here so an EO-authored question never appears as a
 * dark block in the middle of a light form, and let the host page's background
 * show through instead of painting our own canvas over it.
 */
export const useFormsortEmbedTheme = () => {
  useEffect(() => {
    const root = document.documentElement;
    const wasDark = root.classList.contains("dark");

    root.classList.remove("dark");
    root.style.colorScheme = "light";
    root.style.background = "transparent";
    document.body.style.background = "transparent";

    return () => {
      root.style.background = "";
      document.body.style.background = "";

      if (wasDark) {
        root.classList.add("dark");
        root.style.colorScheme = "dark";
      }
    };
  }, []);
};
